import type { TabType } from 'app/components/ui/nav-tabs'

export type PageHeaderProps = {
  className?: string
  title: string
  subTitle?: string
  totalItems?: number | string
  primaryButtonSlot?: React.ReactElement
  secondaryButtonSlot?: React.ReactElement
  otherButtons?: React.ReactElement[]
  tabs?: TabType[]
  learnMore?: React.ReactElement
}

export type UsePageHeaderReturn = {
  className?: string
  title: string
  subTitle?: string
  itemsText?: string
  primaryButtonSlot?: React.ReactElement
  secondaryButtonSlot?: React.ReactElement
  otherButtons?: React.ReactElement[]
  tabs?: TabType[]
  learnMore?: React.ReactElement
}

function getItemsText(totalItems: number | string): string {
  if (typeof totalItems === 'number') {
    return `${totalItems.toLocaleString('en-US')} ${totalItems !== 1 ? 'items' : 'item'}`
  }
  return totalItems
}

export function usePageHeader(props: PageHeaderProps): UsePageHeaderReturn {
  const {
    className,
    title,
    subTitle,
    totalItems,
    primaryButtonSlot,
    secondaryButtonSlot,
    otherButtons,
    tabs,
    learnMore,
  } = props

  return {
    className,
    title,
    subTitle,
    itemsText: totalItems !== undefined ? getItemsText(totalItems) : undefined,
    primaryButtonSlot,
    secondaryButtonSlot,
    otherButtons,
    tabs,
    learnMore,
  }
}
